import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileCloud: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="file-cloud, document">
      <path
        d="M5 10.5V3H13L19 9V21H15M13 4V9H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M3 17.75C3 19.5449 4.45507 21 6.25 21H9C10.3807 21 11.5 19.8807 11.5 18.5C11.5 17.1193 10.3807 16 9 16C8.99626 16 8.99253 16 8.9888 16C8.4116 15.0983 7.40146 14.5 6.25 14.5C4.45507 14.5 3 15.9551 3 17.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconFileCloud;
